module.exports = __webpack_public_path__ + "img/title3_2.fa24c990.png";